export default {"src":"/_next/static/media/HUBC.a8341bf0.svg","height":18,"width":18};